export interface WalletApplicationInput {
  availableCents: number;
  priceCents: number;
}

export interface WalletApplicationResult {
  appliedCents: number;
  remainingCents: number;
  coversFully: boolean;
}

/**
 * Computes how much of a plan's price a clipper's CPM wallet balance covers.
 * A negative balance (netted debt from disqualifications) applies nothing,
 * same as zero.
 */
export function computeWalletApplication({
  availableCents,
  priceCents,
}: WalletApplicationInput): WalletApplicationResult {
  if (priceCents <= 0) {
    return { appliedCents: 0, remainingCents: 0, coversFully: true };
  }

  const appliedCents = Math.min(Math.max(0, availableCents), priceCents);
  const remainingCents = priceCents - appliedCents;

  return {
    appliedCents,
    remainingCents,
    coversFully: remainingCents === 0,
  };
}
